import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { SocketPnlContext } from "@shared/features/dashboard/SocketPnl.context.ts";
import { useTradeSocketPnl } from "@shared/features/socket/hooks.ts";
import { SocketTopics } from "@shared/types";
import { SocketPnlResponse } from "@shared/services/socket/types.ts";

interface PnlSocketDataProviderProps {
  tradeId?: number;
  skip?: boolean;
}

const PnlSocketDataProvider = ({
  tradeId,
  skip,
  children,
}: PropsWithChildren<PnlSocketDataProviderProps>) => {
  const { socketPnlValue, useGlobalPnl } = useContext(SocketPnlContext) || {};
  const singleTradeSocketPnl = useTradeSocketPnl(
    SocketTopics.PNL,
    skip || useGlobalPnl ? undefined : tradeId
  );
  const socketPnl =
    singleTradeSocketPnl || (tradeId ? socketPnlValue?.[tradeId] : undefined);

  const contextValue = useMemo(() => {
    return {
      socketPnl,
    };
  }, [socketPnl]);

  return (
    <PnlSocketDataContext.Provider value={contextValue}>
      {children}
    </PnlSocketDataContext.Provider>
  );
};

export default PnlSocketDataProvider;

export const PnlSocketDataContext = createContext<
  | {
      socketPnl: SocketPnlResponse | undefined;
    }
  | undefined
>(undefined);

export const usePnlSocketData = () => {
  return useContext(PnlSocketDataContext)?.socketPnl;
};
